import $ from 'jquery';
const FIELD_TAXONOMY_FILTER_SELECTOR = '[data-field-type="term-combobox"]';
let $body = $("body");

$.fn.filterTaxonomyField= function(){
    let $field = $(this);
    let $header = $field.find('[data-action="toggle"]');
    $header.on('click',function(e){
        let active = !$field.hasClass('active');
        e.preventDefault;
        $(this).removeClass('active');
        if(active){
            $field.addClass('active');
        }
        $(document).on('mouseup',function (e) {
            if ($(e.target).closest($field).length === 0) {
                $field.removeClass('active');
            }
        });
        
    })


    let updatecount = function(){
       let count = $field.find('input:checked').length;
       $field.find('[data-role="count"]').text(count);
       if(count) {
           $field.addClass('--has-selected-value');
       }else {
           $field.removeClass('--has-selected-value')
       }

    }
    $field.find('input').on('change',updatecount)
    updatecount();

}

$.fn.jobFilterForm = function(){
    let $form = $(this);
    let $searchForm = $(".search-form");
    //$form.on('change', 'input', function(e){
    $form.on('change', '.filter-taxonomy-item-input', function(e){
        
     update();
    })
   

    $searchForm.on('click', '.cta-clear',function(){
        $searchForm.find(".cta-clear").hide();
        $searchForm.find(".search-jobs").val("");
        $searchForm.submit();
    });

    $form.on('submit', function(e){
        e.preventDefault();
        $searchForm.find(".cta-clear").toggle($searchForm.find(".search-jobs").val() !== "");
        update();
    })
    
    $form.on('click','[href="#page-control"]', function(e){
        e.preventDefault();
        let value = $(this).data('value');
        $form.find('#page-control').val(value);
        update();
    })
    $form.on('click', '[data-action="reset"]',function(e){
        console.log('ici');
        e.preventDefault();
        $form.find('input:checked').prop('checked', false);
        $form.find('.--has-selected-value').removeClass('--has-selected-value')
        update();
        $('#pageNum').val(1).trigger('change');
    })

    $form.on('click', '.filter-taxonomy-clear-item',function(e){
        e.preventDefault();
        let $n = e.currentTarget.id;
        $form.find(".filter-taxonomy-item-input[id^='"+$n+"']:checked").prop('checked', false);
        $(FIELD_TAXONOMY_FILTER_SELECTOR).each(function(){
            $(this).filterTaxonomyField();
            $form.find(".filter-taxonomy-item-input[id^='"+$n+"']").attr('checked', false);
        })     
        update();        
    })

    let update = function(){
        let url = $form.serialize();
        url = window.location.pathname+'?'+url;
        $('#pageNum').val(1).trigger('change');
        history.replaceState(null, null, url);
        $.get(url, function(r){
            let $div = $('<div>').html(r);
            let $list = $div.find('.job-list-wrapper');
            if($list.length != 1) {
            }
            $form.find('.job-list-wrapper').html($list.html());
          
        })
        
    }
    $(".alert-modal .cta-close").on('click', function(e) {
        e.preventDefault();
        $(e.currentTarget).parents(".alert-modal").remove();
    });

}


    //------------------------------------------------
    // Job alert
    $.fn.alertFormJob = function(){
        let $FormJob = $(this);
        let $alertForm = $(".create-job-alert-form form");
        $(document).on('click','.open-create-job-alert',function(e){
            e.preventDefault();
            $FormJob.fadeIn().addClass("noscroll");
            $FormJob.find(".second_title").hide()
            $FormJob.find(".first_title").show()
            $FormJob.find(".alert-job-form").show()
            $FormJob.find(".small-wrapper").show()

            if ($(".create-job-alert-form .background video").length > 0) {
                $(".create-job-alert-form .background video")[0].play();
            }
        });
        $(document).on('click','.close-create-job-alert',function(e){
            e.preventDefault()
            $FormJob.fadeOut();
            $alertForm.removeClass("noscroll");
        });
        
        $alertForm.on('submit', function(e){
            let $alertFormCats = $FormJob.find('input:checked').prop('checked', false);
            e.preventDefault();
            let searchQuery = $FormJob.find("input").val(); 
            let params = {
                'action': 'job_alert_form',
                'email': $alertForm.find("input").val(),
            };
            $alertFormCats.each((index, element) => {
                if($(element).val()){
                    params[$(element).attr('name')] = $(element).attr("data-myattri");
                }
            });
            console.log(params)
            $.get(
                ajax_client.ajax_url,
                params,
                (response) => {
                    $FormJob.find(".first_title").hide()
                    $FormJob.find(".alert-job-form").hide()
                    $FormJob.find(".small-wrapper").hide()
                    $FormJob.find(".second_title").show()
                }
            );
            console.log(searchQuery);
        });
    }

//------------------------------------------------
// Application form
$.fn.applicationForm = function() {
    $(".open-application-form").click((e) => {

        e.preventDefault();
        $(".fullpage-form .inner").removeClass("confirm");
        /*
        if ($(".application-form .background video").length > 0) {
            $(".application-form .background video")[0].play();
        }
        */

        $('.header').hide();
        $('.footer-content').hide();
        $(".application-form").fadeIn();
        $(".application-form").addClass("noscroll");

        //$(window).resize();
        adaptBackground();
        setTimeout(() => {
            $(".application-form").find(".block-title, .fade-up").addClass("show");
        }, 200);
    });
        $(".fullpage-form .cta-close").click(() => {
            $('.header').show();
            $('.footer-content').show();
            $(".fullpage-form").fadeOut();
            $(".fullpage-form").removeClass("noscroll");
        });

        $('.file-input-container input[type=file]').change(function (e) {
            $(this).parents(".file-input-container").find(".text").addClass("active").text($(this)[0].files[0].name);
        });

        $(document).on('click', '.wpcf7-submit', function (e) {
            if ($('.ajax-loader').hasClass('is-active')) {
                e.preventDefault();
                return false;
            }

            $(".wpcf7").addClass("loading");
        });

        $(".wpcf7").on('wpcf7submit', function (event) {
            $(".wpcf7").removeClass("loading");
        });

        $(".wpcf7").on('wpcf7mailsent', function (event) {
            let firstName = $(this).find("[name='firstname']").val();
            $(".form-confirmation .block-title i").text(firstName);
            $(this).parents(".form-container").addClass("confirm");
        });

}



//------------------------------------------------
// Job application form
$.fn.jobApplicationForm = function() {
    $(".open-job-application-form").click((e) => {
        e.preventDefault();

        $(".fullpage-form .inner").removeClass("confirm");

        if ($(".job-application-form .background video").length > 0) {
            $(".job-application-form .background video")[0].play();
        }
        $('.header').hide();
        $('.mobile').hide();
        $('.footer-content').hide();
        $('.send-your-application').hide();
        $(".job-application-form").fadeIn();
        $(".job-application-form").addClass("noscroll");
        //$(window).resize();
        adaptBackground();
    });

    $(".job-application-form .cta-close").on("click", function (e) {
        $('.header').show();
        $('.footer-content').show();
        $('.send-your-application').show();
        $(".job-application-form").fadeOut();
        $(".job-application-form").removeClass("noscroll");
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            $('.mobile').show();
        }
    });
    $('.file-input-container input[type=file]').on('change', function(e){
        $(this).parents(".file-input-container").find(".text").addClass("active").text($(this)[0].files[0].name);
    });
    $(".wpcf7").on('wpcf7submit', function (event) {
        $(".wpcf7").removeClass("loading");
    });

    $(".wpcf7").on('wpcf7mailsent', function (event) {
        let firstName = $(this).find("[name='firstname']").val();
        $(".form-confirmation .block-title i").text(firstName);
        $(this).parents(".form-container").addClass("confirm");
    });
}
function adaptBackground(){
    $(".fullpage-form .inner .bg").each(function(){
        $(this).find(".shape").height(Math.max($(this).parent().find(".inner-content").height(), 750));
    });
}

$(function(){
    $('.job-filter-form').each(function(){
        $(this).jobFilterForm();
    })
    $(FIELD_TAXONOMY_FILTER_SELECTOR).each(function(){
        $(this).filterTaxonomyField();
    })
    $('.create-job-alert-form').each(function(){
        $(this).alertFormJob();
    })
    $(this).each(function(){
        $(this).jobApplicationForm();
    })
    $(this).each(function(){
        $(this).applicationForm();
    })
})